module.exports = __webpack_public_path__ + "img/u47.ce56a906.svg";